export const authPaths = {
  absolute: '/auth',
  relative: 'auth',

  login: {
    absolute: '/auth/login',
    relative: 'login',
  },

  ssoLogin: {
    absolute: '/auth/login/sso',
    relative: 'login/sso',
  },

  ssoLoginCallback: {
    absolute: '/auth/login/sso/callback',
    relative: 'login/sso/callback',
  },

  mfa: {
    absolute: '/auth/mfa',
    relative: 'mfa',
  },

  forgotPassword: {
    absolute: '/auth/forgot-password',
    relative: 'forgot-password',
  },

  resetPassword: {
    absolute: '/auth/reset-password',
    relative: 'reset-password',
  },

  setupPassword: {
    absolute: '/auth/setup-password',
    relative: 'setup-password',
  },

  registrationDevices: {
    absolute: '/auth/sdk-eval-signup',
    relative: 'sdk-eval-signup',
  },

  registrationCompute: {
    absolute: '/auth/compute-signup',
    relative: 'compute-signup',
  },

  registrationEmailPrompt: {
    absolute: '/auth/signup-email-prompt',
    relative: 'signup-email-prompt',
  },

  sandboxLogin: {
    absolute: '/auth/sdk-eval',
    relative: 'sdk-eval',
  },
} as const;
